module.exports = __webpack_public_path__ + "img/img-a214bd65.dfdf6399.png";